// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6225":"4ee50d7c","7412":"7776ac4e"}[chunkId] + ".chunk.css";
};